<template>
    <div class="courseContent">
        <!-- 视频播放、未购买提示 -->
        <div class="course-video-purchaseTips">
            <!-- 视频播放、未购买提示 -->
            <slot name="course-video"></slot>
            <!-- 未购买提示 -->
            <slot name="purchaseTipsBox"></slot>
        </div>
        <!-- 购买数、课时数、课程信息、立即购买 -->
        <div class="course-info-purchase">
            <!-- 购买数、课时数 -->
            <div class="course-purchase-num-hour">
                <div class="course-purchase-num textCenter">
                    <slot name="course-purchase-num"></slot>
                    <span>购买数</span>
                </div>
                <div class="bar"></div>
                <div class="course-purchase-hour textCenter">
                    <slot name="course-purchase-hour"></slot>
                    <span>课时数</span>
                </div>
            </div>
            <div class="blakBar"></div>
            <div class="whiteBar"></div>
            <!-- 课程信息、立即购买 -->
            <div class="course-purchase-content" v-if="!isPurchase">
                <slot name="course_title"></slot>
                <div class="real_price">
                    <p>价格：</p>
                    <slot name="real_price"></slot>
                </div>
                <div class="course_lecturer">
                    <p>主讲师：</p>
                    <slot name="course_lecturer_list"></slot>
                </div>
                <div class="validity_term">
                    <div class="validity_term_label">有效期：</div>
                    <div class="validity_term_text">
                        <slot name="startTime"></slot>
                        <slot name="endTime"></slot>
                    </div>
                </div>
                <slot name="payBigBtn"></slot>
            </div>
            <!-- 课程章节list -->
            <div class="course_chapter" v-else>
                <slot name="course_chapter_item"></slot>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props:{
        isPurchase:{
            type:Boolean,
            default:false
        }
    }
};
</script>

<style lang="less" scoped>
.textCenter {
    text-align: center;
}
.courseContent {
    display: flex;
    flex-direction: row;
    height: 406px;
    .course-video-purchaseTips {
        width: 716px;
        height: 100%;
        position: relative;
        .course-video {
            height: 100%;
        }
        .purchaseTipsBox{
            position: absolute;
            left: 0;
            top: 0;
            z-index: 9;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.8);
        }
    }
    .course-info-purchase {
        display: flex;
        flex-direction: row;
        width: 384px;
        height: 100%;
        background: #454545;
        .course-purchase-num-hour {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 120px;
            height: 100%;
            font-size: 16px;
            color: #fff;
            p {
                font-size: 28px;
                margin: 10px 0;
            }
            .bar {
                margin: 56px 0;
                width: 106px;
                height: 1px;
                background: #6b6b6b;
            }
        }
        .blakBar {
            width: 1px;
            background: linear-gradient(
                to bottom,
                #474747 0%,
                #000 50%,
                #474747 100%
            );
        }
        .whiteBar {
            width: 1px;
            background: linear-gradient(
                to bottom,
                #4e4e4e 0%,
                #a4a4a4 50%,
                #4e4e4e 100%
            );
        }
        .course-purchase-content {
            position: relative;
            flex: 1;
            padding: 0 12px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-family: "微软雅黑";
            .payBigBtn {
                margin: 50px auto;
                width: 204px;
                height: 36px;
                line-height: 36px;
                font-size: 16px;
                color: #fff;
                text-align: center;
                border-radius: 18px;
                cursor: pointer;
                background: #ff8e09;
            }
            .validity_term_text span {
                line-height: 22px;
            }
            .validity_term_text {
                flex: 1;
                display: flex;
                flex-direction: column;
            }
            .validity_term_label {
                width: px;
            }
            .validity_term {
                display: flex;
                flex-direction: row;
                font-size: 14px;
                color: #fff;
            }
            .course_lecturer {
                margin-bottom: 8px;
                display: flex;
                flex-direction: row;
                font-size: 14px;
                color: #fff;
                .course_lecturer_list{
                    flex: 1;
                    max-height: 48px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                }
            }
            .real_price h4 {
                color: #ff8e09;
                font-size: 22px;
            }
            .real_price {
                margin-bottom: 16px;
                display: flex;
                flex-direction: row;
                align-items: center;
                color: #fff;
                font-size: 14px;
                height: 50px;
                border-bottom: solid 1px #6b6b6b;
            }
            .course_title {
                max-height: 96px;
                font-size: 18px;
                font-weight: bold;
                line-height: 24px;
                color: #fff;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 4;
                overflow: hidden;
            }
        }
        .course_chapter{
            flex: 1;
            padding: 14px 12px;
            height: 100%;
            overflow-y: auto;
            .course_chapter_item{
                display: flex;
                flex-direction: column;
                justify-content: center;
                height: 62px;
                cursor: pointer;
                .chapter_title {
                    display: flex;
                    flex-direction: row;
                    height: 24px;
                    font-size: 12px;
                    line-height: 24px;
                    color: #aeaeae;
                    >p{
                        color: #32ace5;
                        margin-right: 12px;
                    }
                    >div{
                        flex: 1;
                        height: 24px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
                .time {
                    padding-left: 36px;
                    font-size: 12px;
                    line-height: 24px;
                    color: #767676;
                }
            }
            .course_chapter_item.active{
                .chapter_title {
                    >div{
                        color: #32ace5;
                    }
                }
            }
        }
    }
}
</style>
